import { Mail, Users, MessageCircle } from "lucide-react";

export const StatCard = ({ icon, label, value, highlight }) => (
    <div className={`rounded-2xl p-5 border ${highlight ? "bg-brand-green text-white border-brand-green" : "bg-white border-black/5"}`}>
        <div className={`h-9 w-9 rounded-full ${highlight ? "bg-white/20" : "bg-brand-green-light text-brand-green"} flex items-center justify-center`}>
            {icon}
        </div>
        <div className={`mt-3 font-display text-3xl font-bold ${highlight ? "text-white" : "text-brand-navy"}`}>{value}</div>
        <div className={`text-xs mt-1 ${highlight ? "text-white/80" : "text-muted-foreground"}`}>{label}</div>
    </div>
);

export const AdminStats = ({ dash }) => {
    if (!dash) return null;
    return (
        <div className="grid grid-cols-2 lg:grid-cols-4 gap-4 mb-8" data-testid="admin-stats">
            <StatCard icon={<Mail size={18} />} label="Mensajes totales" value={dash.total_messages} />
            <StatCard icon={<MessageCircle size={18} />} label="Sin leer" value={dash.unread_messages} highlight />
            <StatCard icon={<Users size={18} />} label="Voluntarios" value={dash.total_volunteers} />
            <StatCard icon={<Users size={18} />} label="Pendientes" value={dash.pending_volunteers} highlight />
        </div>
    );
};

export const Empty = ({ text }) => (
    <div className="rounded-2xl border border-dashed border-black/10 bg-white p-12 text-center text-muted-foreground">
        {text}
    </div>
);
